module.exports = __webpack_public_path__ + "img/df37f72.jpg";